var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"section"},[_c('h1',{staticClass:"title"},[_vm._v("Welcome!")]),_c('p',{staticClass:"subtitle"},[_vm._v("Currently analyzing "+_vm._s(_vm.$store.state.movieCount)+"+ movies")])])])}
var staticRenderFns = []

export { render, staticRenderFns }